import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core'

import { ErrorMessage, Container, StyledTextArea } from './styled'

export default function TextArea({ name, label, type, ...rest }) {
  const inputRef = useRef(null);
  const { fieldName, registerField, defaultValue, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value'
    });
  }, [fieldName, registerField]);

  //{/* <input ref={inputRef} defaultValue={defaultValue} {...rest}/> */}

  return (
    <Container type={type}>
      <label htmlFor={fieldName}>{label}</label>

      {<ErrorMessage className="error">{error}&nbsp;</ErrorMessage>}

      <StyledTextArea
        error={error}
        id={fieldName}
        ref={inputRef}
        defaultValue={defaultValue}
        type={type}
        rows={10}
        {...rest}
      />
    </Container>
  )
}